<kzn-dialog [title]="t('declineRequestTitle')" [actionLabel]="t('decline')" [secondaryActionLabel]="t('cancel')"
    (actionFired)="onAction()" (secondaryActionFired)="onSecondaryAction()"
    [isActionDisabled]="reasonForDecline.invalid">
    <div class="content__decline-request">
        <span>{{ t('declineRequestBody') }}</span>
        <mat-form-field appearance="outline" class="input__reason-for-decline">
            <mat-label>{{ t('declineReasonLabel') }}</mat-label>
            <input type="text" matInput [placeholder]="t('declineReasonPlaceholder')" [formControl]="reasonForDecline" />
            <mat-error>{{ t('pleaseFillField') || t('requiredField') || Messages.MSG_ERROR_REQUIRED }}</mat-error>
        </mat-form-field>
    </div>
</kzn-dialog>